<template>
  <div class="d-flex flex-wrap">
    <component :is="iconType" class="profile-icon" />
    <span class="ml-4">{{ text }}</span>
  </div>
</template>

<script>
  import Mobile from '@/@core/components/svg/profile-detail/Phone.vue';
  import Email from '@/@core/components/svg/common/Email.vue';
  import BirthDate from '@/@core/components/svg/profile-detail/Cake.vue';
  import LineId from '@/@core/components/svg/profile-detail/Line.vue';
  import Consent from '@/@core/components/svg/profile-detail/Consent.vue';

  export default {
    components: { Mobile, Email, BirthDate, Consent, LineId },

    props: {
      text: [String, Number, Boolean],
      iconType: String,
    },
    setup() {},
  };
</script>

<style></style>
<style scoped>
  @import '~@/assets/css/pages/data-management/profile-detail.css';
</style>
